module.exports = __webpack_public_path__ + "img/4.15883245.jpeg";